module.exports = __webpack_public_path__ + "static/media/IMAGEN.4107ee31.png";